import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-html-content-dialog',
  template: `
    <div [innerHTML]="safeHtml"></div>
  `
})
export class HtmlContentDialogComponent {
  @Input() 
  set html(value: string) {
    this.safeHtml = this.sanitizer.sanitize(1, value) as string;
  }

  safeHtml: string = '';

  constructor(private sanitizer: DomSanitizer) {}
}

